import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { UniversalRoll } from "../../models/UniversalRoll";
import { getUniversalRolls } from "../../repositories/UniversalRollRepository";
import { TableUniversalRoll } from "./components/TableUniversalRoll";

export const useUniversalRolls = (
	partId?: number,
	onError?: (error: Error) => void,
) => {
	return useQuery<UniversalRoll[], Error>({
		queryKey: ["universalRolls", partId],
		meta: { realtime: ["M2.GetUniversalRolls"] },
		queryFn: ({ signal }) => getUniversalRolls({ partId }, signal),
		onError: onError,
	});
};

export const UniversalRollPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Universal Rolls" />
			<TableUniversalRoll partId={partId} />
		</>
	);
};
